import SettingsVerificationList from './SettingsVerificationList'
export default SettingsVerificationList
